{
  "name": "pacpro-web",
  "version": "1.146.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve -o",
    "start:local": "ng serve -o --configuration local",
    "start:https": "ng serve -o --configuration localhost-ssl",
    "build": "ng build",
    "build:staging": "ng build --configuration=staging",
    "build:deploy:dev": "ng build --configuration=development && rsync -rt --delete -v --stats --progress ./dist/pacpro-web/browser/ sulreport@172.16.107.30:/home/sulreport/development/frontend/",
    "build:deploy:production": "ng build --configuration=production && rsync -rt --delete -v --stats --progress -e \"ssh -i ../chave-aws-pacpro-producao.pem\" ./dist/pacpro-web/browser/ ubuntu@18.231.62.143:/home/ubuntu/production/frontend/",
    "build:deploy:staging": "ng build --configuration=staging && rsync -rt --delete -v --stats --progress ./dist/pacpro-web/browser/ sulreport@172.16.107.30:/home/sulreport/staging/frontend/",
    "build:prod": "ng build --configuration=production",
    "build:demo": "ng build --configuration=demo",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "prepare": "husky"
  },
  "prettier": {
    "printWidth": 120,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "scarfSettings": {
    "enabled": false
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.16",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.16",
    "@angular/compiler": "^21.2.16",
    "@angular/core": "^21.2.16",
    "@angular/forms": "^21.2.16",
    "@angular/platform-browser": "^21.2.16",
    "@angular/platform-browser-dynamic": "^21.2.16",
    "@angular/router": "^21.2.16",
    "@auth0/angular-jwt": "^5.2.0",
    "@ng-icons/core": "^33.2.3",
    "@ng-icons/lucide": "^33.2.3",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@tailwindcss/aspect-ratio": "^0.4.2",
    "@tailwindcss/forms": "^0.5.10",
    "@tailwindcss/typography": "^0.5.16",
    "angular-svg-icon": "^19.1.1",
    "class-variance-authority": "^0.7.1",
    "clsx": "^2.1.1",
    "cssnano": "^7.1.1",
    "date-fns": "^4.4.0",
    "driver.js": "^1.6.0",
    "event-source-polyfill": "^1.0.31",
    "lottie-web": "^5.13.0",
    "ngx-infinite-scroll": "^21.0.0",
    "ngx-lottie": "^21.2.0",
    "ngx-mask": "^21.0.1",
    "ngx-sonner": "^3.1.0",
    "rxjs": "~7.8.2",
    "tailwind-merge": "^3.6.0",
    "tailwind-scrollbar": "^4.0.2",
    "tailwindcss-animate": "^1.0.7",
    "tslib": "^2.8.1",
    "uuid": "^14.0.0",
    "zone.js": "~0.16.0"
  },
  "devDependencies": {
    "@angular/build": "~21.2.14",
    "@angular/cli": "^21.2.14",
    "@angular/compiler-cli": "^21.2.16",
    "@tailwindcss/postcss": "^4.1.13",
    "autoprefixer": "^10.5.0",
    "husky": "^9.1.7",
    "jsdom": "^29.1.1",
    "postcss": "^8.5.15",
    "postcss-import": "^16.1.1",
    "tailwindcss": "^3.4.17",
    "typescript": "~5.9.2",
    "vitest": "^4.1.8"
  }
}
